export type SanctuarySeason = "autumn" | "winter" | "spring" | "summer";
export const SANCTUARY_SEASONS: SanctuarySeason[] = ["autumn", "winter", "spring", "summer"];
export const SANCTUARY_RETURN_KEY = "rt:sanctuary-return";
export const SANCTUARY_JOURNAL_PREFIX = "Healing Sanctuary · ";

/** Date-based season. November joins winter so the room turns cosy as it launches. */
export function seasonForDate(date: Date): SanctuarySeason {
  const m = date.getMonth(); // 0 = Jan
  if (m >= 2 && m <= 4) return "spring";
  if (m >= 5 && m <= 7) return "summer";
  if (m === 8 || m === 9) return "autumn";
  return "winter";
}

/** An admin override wins when it is a known season; otherwise the date decides. */
export function resolveSeason(override: string | null | undefined, date: Date): SanctuarySeason {
  return SANCTUARY_SEASONS.includes(override as SanctuarySeason)
    ? (override as SanctuarySeason)
    : seasonForDate(date);
}

export function sanctuaryJournalTitle(title: string) {
  return `${SANCTUARY_JOURNAL_PREFIX}${title}`.slice(0, 200);
}
